module.exports = __webpack_public_path__ + "img/ClickForSound_38.4b3e494a.png";